import { apiv3 } from "../api/v3/APIv3.js";
import { getServerTime } from "./utils.js";

export class ServerDate {
	static hasInternet = true;
	static offset = 0;
	static synced = false;
	static SERVER_RSP_SYNC = 0;
	static ServerTS = 0;
	static LocalTS = 0;
	static async sync(from?: string) {
		if (!ServerDate.synced) {
			let [hasInternet] = await getServerTime().go();
			ServerDate.hasInternet = Boolean(hasInternet);
		}
		if (!ServerDate.hasInternet) {
			ServerDate.synced = true;
			return;
		}
		let init = Date.ts();
		ServerDate.ServerTS = await apiv3.test.getServerTimestamp();
		let end = Date.ts();
		ServerDate.SERVER_RSP_SYNC = end - init;
		ServerDate.LocalTS = Date.ts();
		ServerDate.offset = ServerDate.ServerTS - ServerDate.LocalTS;
		ServerDate.synced = true;
		console.log(`offset`, ServerDate.offset);
	}
	static ts() {
		if (ServerDate.offset == null) {
			ServerDate.synced = false;
			ServerDate.sync();
		}
		return Date.ts() + (ServerDate.offset || 0);
	}

	static async checkInternetHealth() {
		let r = await fetch(`https://www.apple.com/library/test/success.html`, {
			method: "GET",
			mode: "no-cors",
			cache: "no-cache",
			credentials: "same-origin",
			redirect: "follow",
			referrerPolicy: "no-referrer"
		});
		if (r.status == 0) {
			return true;
		}
		return false;
	}
}
// @ts-ignore
window.ServerDate = ServerDate;
